<div class="admin-container">
    <iframe *ngIf="url" [src]="url" [width]="width" [height]="height" scrolling="no" frameBorder="0"></iframe>
</div>